import serviceDot from "../../common/images/ser-map.png";
import underline from "../../common/images/underline.png";
export default function GlobalReach() {
  return (
    <div className="bg-gradient-to-r from-[#095A9A]  to-[#095A9A]">
      <section className="max-w-[1280px] mx-auto md:px-10 px-5 md:py-7 py-5 flex flex-col md:flex-row items-center gap-10">
        {/* Left Side - Image */}
        <div className="w-full md:w-1/2 flex justify-center">
          <img
            src={serviceDot}
            alt="serviceDot"
            className="max-w-full h-auto"
          />
        </div>

        {/* Right Side - Content */}
        <div className="w-full md:w-1/2 ">
          <div className="text-sm font-normal text-[#FFC400] bg-[#467A90] px-3 py-1 inline-block rounded">
          Global Expansion          </div>
          <h2 className="md:text-5xl text-3xl font-bold md:mt-4 mt-2 text-white">
            Scale seamlessly with advanced tech.
          </h2>
          <div className="underline md:py-3 py-2">
            <img
              alt="underline"
              src={require("../../common/images/underline.png")}
              className="w-[200px] h-[5px]"
            />
          </div>
          <p className="text-gray-200 mt-4">
            We empower businesses to scale beyond limits with innovative and
            strategic solutions. Our deep industry knowledge and technical
            expertise enable us to create platforms that are not only functional
            but also future-proof, ensuring sustainable growth in a rapidly
            evolving market.
          </p>
        </div>
      </section>
    </div>
  );
}
